"use strict";
/**
 * These types should ONLY define the properties of the event. These should
 * represent which unique properties are required for each event, but NOTHING
 * about the implementation of the event itself, e.g. if it's an identify call.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentViewedPropertiesSchema = exports.VideoWatchedPropertiesSchema = exports.OutboundLinkClickedPropertiesSchema = exports.ContactLinkClickedPropertiesSchema = exports.FormSubmittedPropertiesSchema = exports.OnlineMoveInCompletedPropertiesSchema = exports.OnlineMoveInStepViewedPropertiesSchema = exports.OnlineMoveInStartedPropertiesSchema = exports.ReservationCompletedPropertiesSchema = exports.ReservationStartedPropertiesSchema = exports.FacilityMoveInConfirmedPropertiesSchema = exports.FacilityUnitSelectedPropertiesSchema = exports.FacilityViewedPropertiesSchema = exports.FacilityListViewedPropertiesSchema = exports.SearchFilteredPropertiesSchema = exports.SearchSubmittedPropertiesSchema = exports.CtaClickedPropertiesSchema = exports.PageViewedPropertiesSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("./shared");
const page_types_1 = require("./page-types");
/**
 * Properties required when a user views a page.
 */
exports.PageViewedPropertiesSchema = shared_1.BaseEventPropertiesSchema.extend({
    [shared_1.TrackingPropertyKey.PAGE_NAME]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.PAGE_TYPE]: page_types_1.PageTypeSchema
});
/**
 * Properties required when a user clicks a CTA.
 */
exports.CtaClickedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedClickEventPropertiesSchema).extend({
    [shared_1.TrackingPropertyKey.CLICK_URL]: zod_1.z.string().optional(),
});
/**
 * Properties required when a user submits a search.
 */
exports.SearchSubmittedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedSearchPropertiesSchema);
/**
 * Properties required when a user filters a search.
 */
exports.SearchFilteredPropertiesSchema = exports.SearchSubmittedPropertiesSchema;
/**
 * Properties required when a user views a list of facilities.
 */
exports.FacilityListViewedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceFacilitiesPropertiesSchema).extend({
    [shared_1.TrackingPropertyKey.FACILITIES_LIST]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.SEARCH_TERM]: zod_1.z.string(),
});
/**
 * Properties required when a facility is viewed.
 */
exports.FacilityViewedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedFacilityPropertiesSchema);
/**
 * Properties required when a unit is selected.
 */
exports.FacilityUnitSelectedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceFacilityPropertiesSchema)
    .merge(shared_1.SharedEcommerceUnitPropertiesSchema)
    .merge(shared_1.SharedUnitPropertiesSchema)
    .extend({
    [shared_1.TrackingPropertyKey.LAST_UNIT_ADDED_DATE]: shared_1.DateStringSchema,
});
/**
 * Properties required when a move-in is confirmed.
 */
exports.FacilityMoveInConfirmedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceUnitPropertiesSchema)
    .merge(shared_1.SharedUserPropertiesSchema)
    .extend({
    [shared_1.TrackingPropertyKey.ACTUAL_MOVE_IN_DATE]: shared_1.DateStringSchema,
    [shared_1.TrackingPropertyKey.PLANNED_MOVE_IN_DATE]: shared_1.DateStringSchema,
});
/**
 * Properties required when a user starts a reservation.
 */
exports.ReservationStartedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceUnitPropertiesSchema)
    .merge(shared_1.SharedUnitPropertiesSchema)
    .extend({
    [shared_1.TrackingPropertyKey.PRODUCTS]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.CART_PRODUCTS_COUNT]: zod_1.z.number(),
    [shared_1.TrackingPropertyKey.CART_VALUE]: zod_1.z.number(),
    [shared_1.TrackingPropertyKey.CURRENCY]: shared_1.CurrencySchema,
});
/**
 * Properties required when a user completes a reservation.
 */
exports.ReservationCompletedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedReservationPropertiesSchema)
    .merge(shared_1.SharedUnitPropertiesSchema)
    .merge(shared_1.SharedEcommerceUnitPropertiesSchema)
    .merge(shared_1.SharedUserPropertiesSchema)
    .extend({
    [shared_1.TrackingPropertyKey.FIRST_ORDER_DATE]: shared_1.DateStringSchema,
    [shared_1.TrackingPropertyKey.LAST_ORDER_DATE]: shared_1.DateStringSchema,
    [shared_1.TrackingPropertyKey.MOVE_IN_DATE]: shared_1.DateStringSchema,
});
/**
 * Properties required when a user starts an online move-in.
 */
exports.OnlineMoveInStartedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceUnitPropertiesSchema).extend({
    [shared_1.TrackingPropertyKey.RESERVATION_CONFIRMATION]: zod_1.z.string(),
});
/**
 * Properties required when a user views a step in an online move-in.
 */
exports.OnlineMoveInStepViewedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceUnitPropertiesSchema)
    .merge(shared_1.SharedUserPropertiesSchema)
    .extend({
    [shared_1.TrackingPropertyKey.STEP]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.CHECKOUT_STEP]: zod_1.z.string(),
});
/**
 * Properties required when a user completes an online move-in.
 */
exports.OnlineMoveInCompletedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedEcommerceTransactionPropertiesSchema)
    .merge(shared_1.SharedReservationPropertiesSchema)
    .merge(shared_1.SharedUserPropertiesSchema)
    .extend({
    [shared_1.TrackingPropertyKey.FIRST_ORDER_DATE]: shared_1.DateStringSchema,
    [shared_1.TrackingPropertyKey.LAST_ORDER_DATE]: shared_1.DateStringSchema,
});
/**
 * Properties required when a form is submitted.
 */
exports.FormSubmittedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedUserPropertiesSchema).extend({
    [shared_1.TrackingPropertyKey.FORM_TARGET]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.FORM_ID]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.FORM_URL]: zod_1.z.string(),
});
/**
 * Properties required when a contact link is clicked.
 */
exports.ContactLinkClickedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedClickEventPropertiesSchema).extend({
    [shared_1.TrackingPropertyKey.CONTACT_TYPE]: shared_1.ContactTypeSchema,
});
/**
 * Properties required when an outbound link is clicked.
 */
exports.OutboundLinkClickedPropertiesSchema = shared_1.BaseEventPropertiesSchema.merge(shared_1.SharedClickEventPropertiesSchema).merge(shared_1.SharedLinkPropertiesSchema);
/**
 * Properties required when a video is watched.
 */
exports.VideoWatchedPropertiesSchema = shared_1.BaseEventPropertiesSchema.extend({
    [shared_1.TrackingPropertyKey.VIDEO_NAME]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.VIDEO_DURATION]: zod_1.z.number(),
    [shared_1.TrackingPropertyKey.VIDEO_DURATION_PLAYED]: zod_1.z.number(),
});
/**
 * Properties required when an experiment is viewed.
 */
exports.ExperimentViewedPropertiesSchema = shared_1.BaseEventPropertiesSchema.extend({
    [shared_1.TrackingPropertyKey.CATEGORY]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.LABEL]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.EXPERIMENT_SOURCE]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.EXPERIMENT_ID]: zod_1.z.string(),
    [shared_1.TrackingPropertyKey.VARIANT_ID]: zod_1.z.string(),
});
//# sourceMappingURL=properties.js.map